module.exports = __webpack_public_path__ + "img/11_96.fb5dd6fe.png";